// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./skulpturprojekte/src/sass/styles.scss
// module id = 14
// module chunks = 1